import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { IUserProfileRepository } from '../entities/IUserProfileRepository';
import { OTPAuthorizationPhoneResponseBody } from '../entities/OTPAuthorizationPhoneResponseDTO';
import { otpAuthorizationPhoneDTOToOTPAuthorizationPhoneAdapter } from './otpAuthorizationPhoneDTOToOTPAuthorizationPhoneAdapter';

class UserProfileRepositoryImpl implements IUserProfileRepository {
  constructor() {
    this.OTPAuthorizationPhone = this.OTPAuthorizationPhone.bind(this);
    this.UpdatePhone = this.UpdatePhone.bind(this);
    this.CreateEmailAuthorization = this.CreateEmailAuthorization.bind(this);
  }

  OTPAuthorizationPhone(data: GenericObject): Promise<OTPAuthorizationPhoneResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/api/private/users/phone/authorization',
        data,
        dataAdapter: otpAuthorizationPhoneDTOToOTPAuthorizationPhoneAdapter,
      },
    });
  }

  UpdatePhone(data: GenericObject): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: '/secure-web/api/private/users/phone',
        data,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  CreateEmailAuthorization(data: GenericObject<{ newEmail: string }>): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/api/private/users/email/authorization',
        data,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }
}

export { UserProfileRepositoryImpl };
